import '../../styles/fieldset.scss';

import { ReactNode } from 'react';

export interface FieldsetProps {
  children?: ReactNode;
}

export default function Fieldset(props: FieldsetProps) {
  return <fieldset className="govuk-fieldset">{props.children}</fieldset>;
}

export interface LegendProps {
  isPageHeading?: boolean;
  size?: 'l' | 'm' | 's';
  children?: ReactNode;
}

export function Legend({ isPageHeading, size, children }: LegendProps) {
  let className = 'govuk-fieldset__legend';
  if (size) className += ' govuk-fieldset__legend--' + size;
  return isPageHeading ? (
    <legend className={className}>
      <h1 className="govuk-fieldset__heading">{children}</h1>
    </legend>
  ) : (
    <legend className={className}>{children}</legend>
  );
}
